import React, { FC } from 'react';
import { BsInboxFill } from 'react-icons/bs';

import { Avatar, Badge, Flex, Group, Stack, Text, Title } from '@mantine/core';

interface Props {
    title: string;
    active?: boolean;
    latestActivity?: React.ReactNode;
    unread?: number;
}

export const Item: FC<Props> = ({ title, active = false, latestActivity, unread }) => (
    <Flex
        justify={'left'}
        align={'center'}
        style={(theme) => ({
            // border: `1px solid ${theme.colors.gray[3]}`,
            'borderBottom': `1px solid ${theme.colors.gray[3]}`,
            'backgroundColor': active ? theme.colors.gray[2] : 'transparent',
            ':hover': {
                backgroundColor: theme.colors.gray[2],
            },
            // borderRadius: theme.defaultRadius,
            'padding': 0,
            'cursor': 'pointer',
            'height': '60px',
        })}
    >
        <Stack
            gap={3}
            p={12}
            align="stretch"
            justify="center"
            style={(theme) => ({
                'width': '100%',
                'height': '100%',
                'borderLeft': active ? `4px solid ${theme.colors.blue[9]}` : `4px solid ${theme.colors.gray[3]}`,
                ':hover': {
                    borderLeft: `4px solid ${theme.colors.blue[9]}`,
                },
            })}
        >
            <Flex justify="space-between" direction="row">
                <Title order={3}>{title}</Title>
                <Group gap="xxs">
                    {Number(unread) > 0 && (
                        <Badge variant="filled" bg="red.7" leftSection={<BsInboxFill size={10} />}>
                            {unread}
                        </Badge>
                    )}
                </Group>
            </Flex>
            <Flex justify="space-between" direction="row">
                <Group gap={6}>
                    <Avatar radius="lg" size={20} variant="filled">
                        DB
                    </Avatar>
                    <Text size="xs" c="dimmed">
                        {latestActivity}
                    </Text>
                </Group>
                <Text size="xs" c="dimmed">
                    16 min
                </Text>
            </Flex>
        </Stack>
    </Flex>
);
